/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { removeDefaultAnchorStyling } from 'blb-styles/mixins';
import { inputFormatters } from '@blend/shared-react';
import { Text } from '@blend/enterprise-components';
import { SupportContact } from 'src/persona/common';

export const getSupportPhoneAnchor = (phone: string) => (
  <a href={`tel:${phone}`} style={removeDefaultAnchorStyling(true)}>
    {inputFormatters.PHONE.format(phone)}
  </a>
);

export const getSupportEmailAnchor = (email: string) => (
  <a href={`mailto:${email}`} style={removeDefaultAnchorStyling(true)}>
    {email}
  </a>
);

export const getSupportContactPhoneInfo = (supportInfo: SupportContact) =>
  supportInfo.phone ? <Text> or call {getSupportPhoneAnchor(supportInfo.phone)}</Text> : null;
